export default {
  refresh (state) {
    state.refresh = !state.refresh
  }
}
